/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M11.25 7.5a.75.75 0 0 0 0 1.5h2.6893l-6.2196 6.2197a.75.75 0 0 0 1.0607 1.0606L15 10.0607V12.75a.75.75 0 0 0 1.5 0V7.5h-5.25ZM17.2497 6c.2134.284.4662.5369.7503.7503a3.7333 3.7333 0 0 0 2.25.7497C22.3211 7.5 24 5.821 24 3.75 24 1.679 22.3211 0 20.25 0S16.5 1.679 16.5 3.75c0 .8442.279 1.6232.7497 2.25ZM20.25 6c1.2426 0 2.25-1.0074 2.25-2.25S21.4926 1.5 20.25 1.5 18 2.5074 18 3.75 19.0074 6 20.25 6ZM7.5 20.25C7.5 22.3211 5.821 24 3.75 24 1.679 24 0 22.3211 0 20.25s1.679-3.75 3.75-3.75c2.071 0 3.75 1.6789 3.75 3.75ZM3.75 22.5C4.9926 22.5 6 21.4926 6 20.25S4.9926 18 3.75 18 1.5 19.0074 1.5 20.25s1.0074 2.25 2.25 2.25ZM24 20.25c0 2.0711-1.6789 3.75-3.75 3.75s-3.75-1.6789-3.75-3.75 1.6789-3.75 3.75-3.75S24 18.1789 24 20.25Zm-3.75 2.25c1.2426 0 2.25-1.0074 2.25-2.25S21.4926 18 20.25 18 18 19.0074 18 20.25s1.0074 2.25 2.25 2.25ZM7.5 3.75c0 2.071-1.679 3.75-3.75 3.75C1.679 7.5 0 5.821 0 3.75 0 1.679 1.679 0 3.75 0 5.821 0 7.5 1.679 7.5 3.75ZM3.75 6C4.9926 6 6 4.9926 6 3.75S4.9926 1.5 3.75 1.5 1.5 2.5074 1.5 3.75 2.5074 6 3.75 6Z"
    clipRule="evenodd"
  />,
  'DataMapping'
);
